import classes from "./CapacityHero.module.scss";

export const CapacityHero = () => {
  return (
    <>
      {/* Banner */}
      <section className={classes.banner}>
        <div className={classes.banner__overlay}>
          <div className={classes.banner__pattern} aria-hidden="true" />
          <div className={classes.banner__body}>
            <h2 className={classes.banner__body__title}>
              Capacity
              <span>Building</span>
            </h2>
            <p className={classes.banner__body__text}>
              Through our Erasmus+ Capacity-Building projects, we collaborate
              with organizations to create a national impact that can fly
              globally.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default CapacityHero;
